<!--<app-header></app-header>-->
<div class="MainBg">
  <div class="MainInnerForm IFA_Mob_Margin">
    <div *ngIf="!IsMobile" class="SideMenu ValueAdds">
      <div class="SideMenuHeading">Resources</div>
      <div class="SideMenuLinks">
        <ul class="nav nav-tabs">
          <li class="SideMenuLinksInner">
            <a
              routerLink="/value-add-service/branding"
              routerLinkActive="active">
              <img
                src="../../../assets/images/IFA/Reports Icon/Branding_Module_Report.svg"
                width="25"
                class="SideMenuIcon svg"
                type="image/svg+xml"
                pluginspage="http://www.adobe.com/svg/viewer/install/" />
              <span>Branding Images</span>
            </a>
          </li>
          <li class="SideMenuLinksInner">
            <a
              routerLink="/value-add-service/scheme-returns"
              routerLinkActive="active">
              <img
                src="../../../assets/images/IFA/Reports Icon/Top_Returns_Report.svg"
                width="25"
                class="SideMenuIcon svg"
                type="image/svg+xml"
                pluginspage="http://www.adobe.com/svg/viewer/install/" />

              <span>Scheme Returns</span>
            </a>
          </li>
          <li class="SideMenuLinksInner">
            <a
              routerLink="/value-add-service/schemeperformancelumpsum"
              routerLinkActive="active">
              <img
                src="../../../assets/images/IFA/Reports Icon/Performance_Lumpsum.svg"
                width="25"
                class="SideMenuIcon svg"
                type="image/svg+xml"
                pluginspage="http://www.adobe.com/svg/viewer/install/" />
              <span>Scheme Performance</span>
            </a>
          </li>
          <li class="SideMenuLinksInner">
            <a
              class="show active"
              routerLink="/value-add-service/schemeperformancecompare"
              routerLinkActive="active">
              <img
                src="../../../assets/images/IFA/Reports Icon/Performance_Comparison.svg"
                width="25"
                class="SideMenuIcon svg"
                type="image/svg+xml"
                pluginspage="http://www.adobe.com/svg/viewer/install/" />

              <span>Best Scheme Performance</span>
            </a>
          </li>
          <li class="SideMenuLinksInner">
            <a
              routerLink="/value-add-service/scheme-nav"
              routerLinkActive="active">
              <img
                src="../../../assets/images/IFA/Reports Icon/NAVs_report.svg"
                width="25"
                class="SideMenuIcon svg"
                type="image/svg+xml"
                pluginspage="http://www.adobe.com/svg/viewer/install/" />
              <span>Scheme NAV</span>
            </a>
          </li>
          <li class="SideMenuLinksInner">
            <a
              routerLink="/value-add-service/scheme-dividend"
              routerLinkActive="active">
              <img
                src="../../../assets/images/IFA/Reports Icon/Dividends_Report.svg"
                width="25"
                class="SideMenuIcon svg"
                type="image/svg+xml"
                pluginspage="http://www.adobe.com/svg/viewer/install/" />
              <span>Scheme Dividend</span>
            </a>
          </li>
          <!-- <li class="SideMenuLinksInner">
            <a routerLink='/value-add-service/new-nfo' routerLinkActive='active'>
              <img src="../../../assets/images/IFA/Reports Icon/New_NFO_Report.svg" width="25" class="SideMenuIcon svg" type="image/svg+xml"
                pluginspage="http://www.adobe.com/svg/viewer/install/" />
              <span>NFO</span>
            </a>
          </li> -->

          <li class="SideMenuLinksInner">
            <a routerLink="/value-add-service/forms" routerLinkActive="active">
              <img
                src="../../../assets/images/IFA/Reports Icon/MF_Forms.svg"
                width="25"
                class="SideMenuIcon svg"
                type="image/svg+xml"
                pluginspage="http://www.adobe.com/svg/viewer/install/" />
              <span>MF Forms</span>
            </a>
          </li>
          <li class="SideMenuLinksInner" *ngIf="IsSubscribed">
            <a
              routerLink="/value-add-service/scheduleclient"
              routerLinkActive="active">
              <img
                src="../../../assets/images/IFA/Reports Icon/Schedule_Report.svg"
                width="25"
                class="SideMenuIcon svg"
                type="image/svg+xml"
                pluginspage="http://www.adobe.com/svg/viewer/install/" />
              <span>Schedule Report (Beta)</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="FormTemplate">
      <div>
        <div *ngIf="!IsMobile" class="SectionHeading">
          Best Scheme Performance
        </div>
        <div
          *ngIf="IsMobile"
          class="CommonSelectBoxTabsOuter CommonSelectBoxForm">
          <div class="SectionTopHeading HeadingReport NewHeaders fixed-top p-0">
            <span class="Mob_Heading_Top">Resources</span>
          </div>
          <div
            class="ResourcesTabs CustomTabs_IFA ScrollTabs PortfolioScrollTabs NewCustomTabs">
            <ul class="nav nav-tabs p-0 Reports_Mob">
              <li>
                <a
                  routerLink="/value-add-service/branding"
                  routerLinkActive="active">
                  Branding Images
                </a>
              </li>
              <li>
                <a
                  routerLink="/value-add-service/scheme-returns"
                  routerLinkActive="active">
                  Scheme Returns
                </a>
              </li>
              <li class="d-none">
                <a
                  routerLink="/value-add-service/schemeperformancelumpsum"
                  routerLinkActive="active">
                  Lumpsum Performance
                </a>
              </li>
              <li class="d-none">
                <a
                  routerLink="/value-add-service/new-nfo"
                  routerLinkActive="active">
                  NFO
                </a>
              </li>
            </ul>
          </div>
        </div>
        <form
          autocomplete="off"
          [formGroup]="Transactionform"
          class="FormOuter_Mob">
          <div class="MinLeftFormHeightTransact">
            <div class="row">
              <div class="col-md-4 col-sm-6 col-xs-12 InputBoxOuter">
                <div class="has-float-label">
                  <ng-multiselect-dropdown-angular7
                    [ngModelOptions]="{ standalone: true }"
                    [placeholder]="'Select AMC Name'"
                    [data]="SelectedAMC"
                    [(ngModel)]="selectedItemsAMC"
                    [settings]="dropdownSettings"
                    (onSelect)="onItemSelect($event)"
                    (onDeSelect)="onItemSelect($event)"
                    (onSelectAll)="onItemSelectDeselectAll($event, 0)"
                    (onDeSelectAll)="
                      onItemSelectDeselectAll($event, 1)
                    "></ng-multiselect-dropdown-angular7>
                  <label>AMC Name</label>
                </div>
              </div>

              <div class="col-md-4 col-sm-6 col-xs-12 InputBoxOuter">
                <div class="has-float-label">
                  <select
                    formControlName="Asset_type"
                    class="form-control CommonSelectBox TbxMarginBtm CustomSelect6">
                    <option value="" disabled="true" Selected>
                      select Asset Type
                    </option>
                    <option value="1">Equity</option>
                    <option value="2">Debt</option>
                    <option value="3">Hybrid</option>
                    <option value="4">Commodity</option>
                  </select>
                  <label>Asset Class</label>
                  <!-- <div *ngIf="TransactionSubmitted && l.Asset_type.errors" class="invalid-feedback">
                                <div *ngIf="l.Asset_type.errors.required">Please Select Asset Class</div>
                            </div> -->
                </div>
              </div>

              <!-- <div class="col-md-4 col-sm-6 col-xs-12 InputBoxOuter ">
                            <div class="has-float-label">
                              <input type="text" id="AmountI" formControlName="Amount"
                  [ngClass]="{ 'is-invalid': TransactionSubmitted && l.Amount.errors }"
                  class="form-control CommonTextBox TbxMarginBtm" placeholder="&nbsp;"
                  (keypress)="ValidatePattern('Number',$event)"  />
                <label for="AmountI">Invested Amount</label>
                <div *ngIf="TransactionSubmitted && l.Amount.errors" class="invalid-feedback">
                  <div *ngIf="l.Amount.errors.required">Invested Amount is required</div>
                  <div *ngIf="l.Amount.errors.pattern">Please enter valid Invested Amount</div>
                  </div>
                            </div>
                        </div> -->
            </div>
            <div class="row">
              <div class="col-md-4 col-sm-6 col-xs-12 InputBoxOuter d-block">
                <div class="has-float-label">
                  <select
                    formControlName="SchemeOption"
                    class="form-control CommonSelectBox TbxMarginBtm CustomSelect5"
                    [ngClass]="{
                      'is-invalid':
                        TransactionSubmitted && l.SchemeOption.errors
                    }">
                    <!-- <option value="" disabled='true'>Scheme Option</option>                                     -->
                    <option value="1" selected>Growth</option>
                    <option value="2">IDCW</option>
                  </select>
                  <label>Scheme Option</label>
                  <div
                    *ngIf="TransactionSubmitted && l.SchemeOption.errors"
                    class="invalid-feedback">
                    <div *ngIf="l.SchemeOption.errors.required">
                      Please Select Scheme Option
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-4 col-sm-6 col-xs-12 InputBoxOuter">
                <div class="has-float-label">
                  <select
                    formControlName="SubAsset_type"
                    class="form-control CommonSelectBox TbxMarginBtm CustomSelect3"
                    [ngClass]="{
                      'is-invalid':
                        TransactionSubmitted && l.SubAsset_type.errors
                    }">
                    <option value="" disabled="true">
                      Select Sub Asset Type
                    </option>
                    <option
                      *ngFor="let nature of SelectedSubAsset"
                      [value]="nature.VALUEFIELD">
                      {{ nature.TEXTFIELD }}
                    </option>
                  </select>
                  <label>Sub Asset Class</label>
                  <div
                    *ngIf="TransactionSubmitted && l.SubAsset_type.errors"
                    class="invalid-feedback">
                    <div *ngIf="l.SubAsset_type.errors.required">
                      Please Select Sub Asset Class
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-4 col-sm-6 col-xs-12 InputBoxOuter">
                <div class="has-float-label">
                  <ng-multiselect-dropdown-angular7
                    [ngModelOptions]="{ standalone: true }"
                    [placeholder]="'Select Scheme Name'"
                    [data]="SelectedScheme"
                    [(ngModel)]="selectedItems2"
                    [settings]="dropdownSettings2"
                    (onSelect)="onItemSelect2($event)"
                    (onDeSelect)="onItemSelect2($event)"
                    (onSelectAll)="onItemSelectDeselectAll2($event, 0)"
                    (onDeSelectAll)="
                      onItemSelectDeselectAll2($event, 1)
                    "></ng-multiselect-dropdown-angular7>
                  <label>Scheme Name</label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4 col-sm-6 col-xs-12 InputBoxOuter">
                <div class="has-float-label">
                  <input
                    type="text"
                    id="AmountI"
                    formControlName="Amount"
                    [ngClass]="{
                      'is-invalid': TransactionSubmitted && l.Amount.errors
                    }"
                    class="form-control CommonTextBox TbxMarginBtm"
                    placeholder="&nbsp;"
                    (keypress)="ValidatePattern('Number', $event)" />
                  <label for="AmountI">Investment Amount</label>
                  <div
                    *ngIf="TransactionSubmitted && l.Amount.errors"
                    class="invalid-feedback">
                    <div *ngIf="l.Amount.errors.required">
                      Invested Amount is required
                    </div>
                    <div *ngIf="l.Amount.errors.pattern">
                      Please enter valid Invested Amount
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-4 col-sm-6 col-xs-12 InputBoxOuter">
                <div class="has-float-label">
                  <input
                    type="text"
                    id="FromDate"
                    formControlName="FromDate"
                    [ngClass]="{
                      'is-invalid': TransactionSubmitted && l.FromDate.errors
                    }"
                    class="form-control CommonTextBox TbxMarginBtm clsDatePickerFromDate clsCommonDatePicker"
                    placeholder="&nbsp;" />
                  <label for="FromDate">Investment Date</label>
                  <div
                    *ngIf="TransactionSubmitted && l.FromDate.errors"
                    class="invalid-feedback">
                    <div *ngIf="l.FromDate.errors.required">
                      Please Select Investment Date
                    </div>
                    <div *ngIf="l.FromDate.errors.pattern">
                      Please Enter Valid Investment Date
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-4 col-sm-6 col-xs-12 InputBoxOuter">
                <div class="has-float-label">
                  <input
                    type="text"
                    formControlName="ToDate"
                    id="ToDate"
                    [ngClass]="{
                      'is-invalid': TransactionSubmitted && l.ToDate.errors
                    }"
                    class="form-control CommonTextBox TbxMarginBtm clsDatePickerToDate clsCommonDatePicker"
                    placeholder="&nbsp;" />
                  <label for="ToDate">Value as on Date</label>
                  <div
                    *ngIf="TransactionSubmitted && l.ToDate.errors"
                    class="invalid-feedback">
                    <div *ngIf="l.ToDate.errors.required">
                      Please Select Value as on Date
                    </div>
                    <div *ngIf="l.ToDate.errors.pattern">
                      Please Enter Valid Date
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="SubmitMarginTop">
            <button
              class="CommonSubmitButton"
              [disabled]="Transactionform.value == '' || !Transactionform.valid"
              (click)="onSubmitTransaction()">
              Show Report
            </button>
          </div>
          <!-- <div class="SubmitMarginTop">
                      <button class="CommonSubmitButton" [disabled]="" (click)="ExportTOExcelALL()">Export To Excel</button>
                  </div> -->
          <!--<h6>{{Transactionform.value | json}}</h6> -->
        </form>
      </div>
    </div>
  </div>
  <div id="TblReportSection">
    <div
      [ngClass]="IsShowReport ? 'd-block' : 'd-none'"
      class="MainInnerFormWithoutFlex mt-0">
      <div class="SectionTopHeading w-100">
        <span class="ReportHead">
          <b>Scheme Performance Comparison (Open Ended Scheme)</b>
        </span>
        <div class="RightSideTabs">
          <ul class="nav nav-tabs p-0">
            <!-- <button *ngIf="!IsCallCenterTeam" class=" ml-2" (click)='ExportToPdf()'>
                                    <img
                                    src="../../../assets/images/PDF_Export.svg"
                                    class="ExportToIcon"
                                    type="image/svg+xml"
                                    fill="#fff"
                                    width="12px"
                                    pluginspage="http://www.adobe.com/svg/viewer/install/"/></button> -->
            <button class="ml-2" (click)="ExportTOExcelALL()">
              <img
                src="../../assets/images/IFA/Excel_Export.svg"
                class="ExportToIcon"
                type="image/svg+xml"
                fill="#fff"
                width="12px"
                style="width: 27px !important; height: 29px !important"
                pluginspage="http://www.adobe.com/svg/viewer/install/" />
            </button>
          </ul>
        </div>
      </div>
      <div class="">
        <div *ngIf="!IsMobile" class="tab-content pt-0">
          <div id="SchemeReport" class="tab-pane fade show active">
            <table id="dataTable" class="CommonTable ClsReportTable w-100">
              <thead>
                <tr>
                  <th class="no-sort">Scheme Name</th>
                  <th class="no-sort text-right">Investment Date</th>
                  <th class="no-sort text-right">Investment Amount</th>
                  <th class="no-sort text-right">Buy NAV</th>
                  <th class="no-sort text-right">Units Alloted</th>
                  <th class="no-sort text-right">Valuation Date</th>
                  <th class="no-sort text-right">NAV of Valuation Date</th>
                  <th class="text-right">Valuation Amount</th>
                  <th class="text-right">Abs. Returns(%)</th>
                  <th class="text-right">CAGR(%)</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let c of ReportData">
                  <td>{{ c.Scheme_Name }}</td>
                  <td class="text-right">{{ c.Investment_Date }}</td>
                  <td class="text-right">
                    {{ c.Investment_Amount | number: '1.2-2' }}
                  </td>
                  <td class="text-right">{{ c.Buy_NAV }}</td>
                  <td class="text-right">{{ c.Units_Alloted }}</td>
                  <td class="text-right">
                    {{ c.Valuation_Date.slice(0, 10) }}
                  </td>
                  <td class="text-right">{{ c.NAVonValuation_Date }}</td>
                  <td class="text-right">
                    {{ c.Valuation_Amount | number: '1.2-2' }}
                  </td>
                  <td class="text-right">{{ c.AbsReturn }}</td>
                  <td class="text-right">{{ c.CAGR }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- <p>HIIIII</p> -->
      </div>
    </div>
    <!-- <div *ngIf='!IsMobile' class="tab-content pt-0 ">
            <div id="SchemeReport" class="tab-pane fade show active">
                <table id="ReportTable" class="CommonTable ClsReportTable">
                    <thead>
                        <tr>
                            <th>AMC Name</th>
                            <th>Scheme Name</th>
                            <th>Sub Asset Class</th>
                            <th>Scheme Type</th>
                            <th>Scheme Option</th>
                            <th> Fund Manager</th>
                            <th>Launch Date</th>
                            <th>AUM</th>
                            <th>NAV</th>
                            <th>1W(%)</th>
                            <th>1M(%)</th>
                            <th>3M(%)</th>
                            <th>6M(%)</th>
                            <th>1Y(%)</th>
                            <th>2Y(%)</th>
                            <th>3Y(%)</th>
                            <th>4Y(%)</th>
                            <th>5Y(%)</th>
                            <th>Inception</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let c of ReportData">
                            <td>{{c.AMC_Name}}</td>
                            <td>{{c.SchemeName}}</td>
                            <td>{{c.Sub_Asset_Class}}</td>
                            <td>{{c.Scheme_Type}}</td>
                            <td>{{c.Scheme_Option}}</td>
                            <td>{{c.FundManager}}</td>
                            <td>{{c.Launchdate| date: 'dd/MM/yyyy'}}</td>
                            <td>{{c.AUM}}</td>
                            <td>{{c.Nav}}</td>
                            <td>{{c.Returns_1W}}</td>
                            <td>{{c.Returns_1M}}</td>
                            <td>{{c.Returns_3M}}</td>
                            <td>{{c.Returns_6M}}</td>
                            <td>{{c.Returns_1Y}}</td>
                            <td>{{c.Returns_2Y}}</td>
                            <td>{{c.Returns_3Y}}</td>
                            <td>{{c.Returns_4Y}}</td>
                            <td>{{c.Returns_5Y}}</td>
                            <td>{{c.Returns_Inception}}</td>
                        </tr>
                    </tbody>

                </table>
            </div>


        </div>  -->
  </div>
</div>

<span *ngIf="!IsMobile">
  <app-footer></app-footer>
</span>
